import { render } from "./QuotesList.vue?vue&type=template&id=7962979c&scoped=true"
import script from "./QuotesList.vue?vue&type=script&lang=js"
export * from "./QuotesList.vue?vue&type=script&lang=js"

import "./QuotesList.vue?vue&type=style&index=0&id=7962979c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7962979c"]])

export default __exports__